import { shouldUnsubscribe } from "../ShouldUnsubscribe";
export function subscribe(store, conn, r, ids) {
    const { qID, qPrevID, qPrev } = ids;
    if (typeof r.query === "undefined" ||
        (qID && !store.getQueryByID(qID))) {
        return;
    }
    if (shouldUnsubscribe(store, qID, qPrev)) {
        conn.send({
            name: "Unsubscribe",
            params: { id: qID || qPrevID }
        });
    }
    conn.send(r.query);
}
//# sourceMappingURL=Subscribe.js.map